// client/src/hooks/useRecibo.js
import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';

/**
 * Hook para buscar dados do recibo para um agendamento específico e template.
 *
 * @param {string} agendamentoId - O ID do agendamento.
 * @param {string} templateId - O ID do template de recibo.
 * @param {object} options - Opções de configuração do useQuery.
 * @returns {object} O resultado da query contendo dados do recibo, status de carregamento e erros.
 */
export const useReciboData = (agendamentoId, templateId, options = {}) => {
    return useQuery({
        queryKey: ['reciboData', agendamentoId, templateId],
        queryFn: async () => {
            if (!agendamentoId || !templateId) {
                console.warn("FRONTEND LOG: fetchReciboData - agendamentoId ou templateId não fornecidos. Pulando busca.");
                return null;
            }
            // ✅ CORREÇÃO: a rota real é /recibos/gerar/... (server/routes/recibosRoutes.js);
            // /recibos/data/... nunca existiu, então essa chamada sempre resultava em 404.
            const url = `/recibos/gerar/${agendamentoId}/${templateId}`;
            const response = await apiClient.get(url);
            // response.data.data já é o HTML final, com as variáveis substituídas pelo
            // backend (server/controllers/recibosController.js: getReciboData) — não é um
            // objeto de dados brutos, não precisa (nem deve) ser reprocessado no frontend.
            return response.data.data;
        },
        enabled: options.enabled ?? false, 
        staleTime: options.staleTime || 0, 
        cacheTime: options.cacheTime || 5 * 60 * 1000, 
        onError: (error) => {
            console.error("FRONTEND LOG: useReciboData - Erro ao buscar dados do recibo:", error);
            if (options.onError) {
                options.onError(error);
            }
        },
        refetchOnWindowFocus: false,
    });
};